module.exports = require("dom-helpers/events/off");


//////////////////
// WEBPACK FOOTER
// external "dom-helpers/events/off"
// module id = 20
// module chunks = 0